import React, { ChangeEvent, FC, useMemo, useState } from "react";
import { Collapse, FormControl, FormGroup, FormLabel, TextField } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

import CheckBox from "../../../../../components/elements/CheckBox";
import classes from "../../RoleTitleSelectionSlide.module.scss";
import { CookieSet, RoleTitleGroup as RoleTitleGroupType } from "../../../../../types/campaignTypes";

type RoleTitleGrouptProps = {
  checkBoxes: Record<string, boolean>;
  roleTitleGroup: RoleTitleGroupType;
  handleChange: (cookieSet: CookieSet[]) => (event: ChangeEvent<{}>) => void;
  handleSelectAll: (roleType: RoleTitleGroupType) => (event: ChangeEvent<{}>) => void;
};

const RoleTitleGroup: FC<RoleTitleGrouptProps> = ({ checkBoxes, roleTitleGroup, handleChange, handleSelectAll }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const handleToggle = () => setOpen((prev) => !prev);

  const filteredRoles = useMemo(() => {
    if (!search.trim()) return roleTitleGroup.roleSet;
    return roleTitleGroup.roleSet.filter((roleSet) => roleSet.role.toLowerCase().includes(search.toLowerCase()));
  }, [search, roleTitleGroup.roleSet]);

  return (
    <div className={classes.roleTitleGroupContainer}>
      <FormControl component="fieldset" fullWidth>
        <div className={classes.roleTitleHeader}>
          <FormLabel
            component="legend"
            className={classes.roleTypeLabel}
            onClick={handleToggle}
            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            {open ? <ExpandLess /> : <ExpandMore />}
            <span style={{ marginLeft: 8 }}>{roleTitleGroup.roleType}</span>
          </FormLabel>
        </div>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <div className={classes.searchWrapper}>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search roles..."
              fullWidth
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className={classes.searchInput}
            />
          </div>

          <FormGroup>
            <CheckBox
              checked={!!checkBoxes[`${roleTitleGroup.roleType}_ALL`]}
              onChange={handleSelectAll(roleTitleGroup)}
              name={`${roleTitleGroup.roleType}_ALL`}
              label="Select all"
              className={classes.checkbox}
            />
            {filteredRoles.map((roleSet) => (
              <CheckBox
                key={roleSet.role}
                checked={!!checkBoxes[`${roleTitleGroup.roleTypeId}:${roleSet.roleId}`]}
                name={`${roleTitleGroup.roleTypeId}:${roleSet.roleId}`}
                label={roleSet.role}
                className={classes.checkbox}
                onChange={handleChange(roleSet.cookieSets)}
              />
            ))}
          </FormGroup>
        </Collapse>
      </FormControl>
    </div>
  );
};

export default RoleTitleGroup;
